import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import useOutsideClick from "Root/hooks/useOutsideClick";
import hasScroll from "Root/quiz/helpers/hasScroll/hasScroll";
const PopUp = (props) => {
    const ref = useRef(null);
    const [styles, setStyles] = useState();
    /* function getWindowDimensions() {
      const { innerWidth: width, innerHeight: height } = window;
      return {
        width,
        height,
      };
    } */
    const applyStyles = () => {
        setStyles({
            paddingBottom: hasScroll() ? "42px" : "26px",
        });
    };
    useOutsideClick(ref, () => props.close());
    return (_jsx(_Fragment, { children: _jsx(CSSTransition, { onEnter: applyStyles, in: props.open, timeout: 360, classNames: "top-bar", children: _jsxs("div", { ref: ref, style: styles, className: "translucent_pop_up popup", children: [props.text && _jsx("h4", { children: props.text }), props.children] }) }) }));
};
export default memo(PopUp);
